module.exports = __webpack_public_path__ + "img/cuff_button_diameter.cf3dfff2.png";